module.exports = __webpack_public_path__ + "img/photo.06d1369b.webp";